module.exports = __webpack_public_path__ + "img/member.d5951f5b.png";